import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Entry = ({ name, image, value, updateFilterValue, selectedInps, removeActive }) => {
  const [active, setActive] = useState(false)

  const [ t ] = useTranslation();

  const updateFilter = useCallback(
    () => {
      updateFilterValue("pattern", value);
    },
    [updateFilterValue, value],
  );

  useEffect(() => {
    selectedInps === value ? setActive(true) : setActive(false)
  }, [selectedInps])

  return (
    <div className={"card " + (active ? "active" : "")} onClick={() => {
      updateFilter();
      removeActive();
      }}>
      <div className="preview" style={{ backgroundImage: `url(${image})`, }}></div>
      <p>{t(name)}</p>
    </div>
  )
}

export default Entry
